import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const useSanitizedTranslation = () => {
  const { t } = useTranslation();

  const tSanitized = (key: string) => {
    try {
      return DOMPurify.sanitize(t(key));
    } catch {
      console.warn('WARNING: Failed to sanitize translation for key:', key);
      return key;
    }
  };

  return { t, tSanitized };
};

export default useSanitizedTranslation;
